import _ from "lodash";
import BaseListTileView from "scripts/views/baseListTileView";
import templateChapterListTile from "templates/chapterListTile.hbs";

class ChapterListTileView extends BaseListTileView {
  get template() {
    return templateChapterListTile;
  }

  get events() {
    return _.extend({}, super.events, {
      "click .btn-bookshelf": "onClickBookshelfButton",
    });
  }

  constructor(options) {
    super(options);

    if (this.bookshelfAvailable()) {
      this.initializeBookshelfDeps();
    }
  }

  render() {
    const user = this.securityService.getUser();
    const modelData = this.model.toJSON();

    const templateData = _.merge(modelData, {
      viewerUrl: `/viewer/${modelData.id}`,
      showBadges: user.getShowBadges(),
      parentContentTitle: modelData.parentContent
        ? modelData.parentContent.title
        : null,
      parentContentId: modelData.parentContent
        ? modelData.parentContent.id
        : null,
      thumbnailUrl: modelData.parentContent
        ? modelData.parentContent.thumbnailUrl
        : modelData.thumbnailUrl,
      downloadUrl: this.getDownloadUrl(),
    });

    this.$el.html(this.template(templateData));

    this.initDetailButton();
    this.initFavoriteButton();
    this.initCurationAddButton();
    this.initTooltips();
    this.addContributors(this.model.get("contributors"));

    if (this.bookshelfAvailable()) {
      this.renderBookshelfElements();
    }

    this.initializeDownloadButton();

    return this;
  }
}

export default ChapterListTileView;
